function removeBlankField(record) {
    return Object.fromEntries(
        Object.entries(record).filter(([key, val]) => String(val).trim() !== '')
    );
}

function getFile(filePath) {
    var X = new XMLHttpRequest();
    X.open('GET', filePath, false);
    X.send();
    return X.responseText;
}

export { removeBlankField, getFile }